import React from 'react';
import '../css/IntroHeader.css';
import logoImage from '../css/img/Main_Logo.png';
import { useNavigate } from 'react-router-dom';

const IntroHeader = () => {
  const navigate = useNavigate();
  return (
    <div className="intro-header-container">
      <div className="intro-header-content">
        <img src={logoImage} alt="AI Groove Logo" className="intro-header-logo" />
        <div className="intro-header-right">
          <span className="app-download"><b>APP</b> 다운로드</span>
          <span className="admin-login" onClick={() => navigate('/login')}>관리자 로그인</span>
        </div>
      </div>
    </div>
  );
};

export default IntroHeader; 